import { extend } from '../../../util/jquery';
import { getValue } from '../../../util/object';
export function marketsAutoCompleteTransform(data) {
    const resultObj = extend({}, data);
    resultObj.result = (data.result || []).map(d => {
        const item = {
            mstarType: getValue(d, 'OS010'),
            mstarSymbol: getValue(d, 'OS001'),
            rtType: getValue(d, 'AC003'),
            rtExchangeId: getValue(d, 'AC018'),
            rtSymbol: getValue(d, 'AC001'),
            clientSymbol: getValue(d, 'AC038'),
            performanceId: getValue(d, 'OS06Y'),
            securityId: getValue(d, 'SecId'),
            name: getValue(d, 'OS01W,Name'),
            frenchName: getValue(d, 'AC054'),
            isADR: getValue(d, 'AA0A6'),
            mstarType2: getValue(d, 'ST816'),
            currency: getValue(d, 'Currency')
        };
        if (item.rtExchangeId && item.rtType && item.rtSymbol) {
            item.quoteInstrument = item.instrument = [
                item.rtExchangeId,
                item.rtType,
                item.rtSymbol
            ].join('.');
        }
        return item;
    });
    return resultObj;
}
